import { lazy } from "react";
import { createBrowserRouter, type RouteObject } from "react-router";
import ROUTES from "./routes";
import AuthGuard from "./AuthGuard";
import NotFoundPage from "../../pages/NotFoundPage";

const IpgResultMiddleware = lazy(() => import("./IpgResultMiddleware"));
const Pay = lazy(() => import("../../pages/pay/PayPage"));
const QrCode = lazy(() => import("../../pages/qrCode/QrCodePage"));
const Charge = lazy(() => import("../../pages/charge/ChargePage"));
const InternetPackage = lazy(() => import("../../pages/internetPackage/InternetPackagePage"));
const PayWithCode = lazy(() => import("../../pages/payWithCode/PayWithCodePage"));
const Splash = lazy(() => import("../../pages/splash/SplashPage"));
const Services = lazy(() => import("../../pages/services/ServicesPage"));
const Transactions = lazy(() => import("../../pages/transactions/TransactionsPage"));
const Profile = lazy(() => import("../../pages/profile/ProfilePage"));
const Login = lazy(() => import("../../pages/login/LoginPage"));
const EditProfile = lazy(() => import("../../pages/editProfile/EditProfilePage"));
const Password = lazy(() => import("../../pages/password/PasswordPage"));
const TransactionDetailsPage = lazy(
  () => import("../../pages/transactionDetails/TransactionDetailsPage"),
);
const TopupPage = lazy(() => import("../../pages/topup/TopupPage"));
const Checkout = lazy(() => import("../../pages/checkout/CheckoutPage"));
const ReferralPage = lazy(() => import("../../pages/referral/ReferralPage"));

const appRoutes: RouteObject[] = [
  {
    path: ROUTES.splash,
    element: <Splash />,
  },
  {
    path: ROUTES.login,
    element: <Login />,
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: ROUTES.pay,
        element: <Pay />,
      },
      {
        path: ROUTES.directQrPay,
        element: <QrCode />,
      },
      {
        path: ROUTES.services,
        element: <Services />,
      },
      {
        path: ROUTES.mobileRecharge,
        element: <Charge />,
      },
      {
        path: ROUTES.mobileInternet,
        element: <InternetPackage />,
      },
      {
        path: ROUTES.transactions,
        element: <Transactions />,
      },
      {
        path: ROUTES.transactionDetails,
        element: <TransactionDetailsPage />,
      },
      {
        path: ROUTES.profile,
        element: <Profile />,
      },
      {
        path: ROUTES.password,
        element: <Password />,
      },
      {
        path: ROUTES.payWithCode,
        element: <PayWithCode />,
      },
      {
        path: ROUTES.editProfile,
        element: <EditProfile />,
      },
      {
        path: ROUTES.topup,
        element: <TopupPage />,
      },
      {
        path: ROUTES.checkout,
        element: <Checkout />,
      },
      {
        path: ROUTES.referal,
        element: <ReferralPage />,
      },
      {
        path: ROUTES.failedIpg,
        element: <IpgResultMiddleware success={false} />,
      },
      {
        path: ROUTES.successIpg,
        element: <IpgResultMiddleware success={true} />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

const router = createBrowserRouter(appRoutes);

export default router;
